import React, { FC } from 'react'

import { ProjectItemDetail } from 'modules/Projects/components'

import { IProjectItem } from './ProjectItem.props'
import { useZoneTag } from 'modulesCommon/serviceHooks'

const ProjectItem: FC<IProjectItem> = ({ project, units, artistName }) => {
  const unitLabel = units.find((unit) => unit.id === `${project.unit_id}`)?.name || ''
  const { isSameLabel, isSpace, label } = useZoneTag(`${project.label_id}`)

  return (
    <ProjectItemDetail
      project={project}
      unit={unitLabel}
      artistName={artistName}
      label={isSpace ? label : undefined}
      isSameLabel={isSameLabel}
    />
  )
}

export default ProjectItem
